import { localize } from '@vee-validate/i18n'

localize({
  ja: {
    messages: {
      email: '{_field_} は有効なメールアドレスではありません。',
    }
  }
})